import React from 'react';
import ComboTotalPage from './components/ComboTotalPage';

function ComboTotalDiogo() {
  return <ComboTotalPage paymentUrlOverride="https://pay.kiwify.com.br/yKYVFMc" />;
}

export default ComboTotalDiogo;
